(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product[data-section-id]').forEach(function (root) {
      var form = root.querySelector('.product__form');
      var dataEl = document.getElementById('product-variants-' + root.dataset.sectionId);
      if (!form || !dataEl) return;

      var variants = JSON.parse(dataEl.textContent);
      var idInput = form.querySelector('.product__variant-id');
      var submitButton = form.querySelector('.product__submit');
      var priceEl = root.querySelector('.product__price-current');
      var gallery = root.querySelector('[data-product-gallery]');
      var errorEl = form.querySelector('[data-product-error]');
      var availableLabel = submitButton.dataset.availableLabel || submitButton.textContent.trim();
      var soldOutLabel = submitButton.dataset.soldOutLabel || availableLabel;

      function findMatchingVariant() {
        var fieldsets = form.querySelectorAll('.variant-picker__option');
        if (fieldsets.length === 0) return variants[0];
        var values = Array.prototype.map.call(fieldsets, function (fieldset) {
          var checked = fieldset.querySelector('.variant-picker__input:checked');
          return checked ? checked.value : null;
        });
        return variants.filter(function (variant) {
          var variantValues = [variant.option1, variant.option2, variant.option3];
          return values.every(function (value, index) {
            return value === variantValues[index];
          });
        })[0];
      }

      function updateForVariant(variant) {
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) {
          var formatted = (variant.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
          priceEl.textContent = formatted;
        }
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available ? availableLabel : soldOutLabel;
        if (gallery && variant.featured_image && typeof gallery.activateByImageId === 'function') {
          gallery.activateByImageId(variant.featured_image.id);
        }
      }

      form.querySelectorAll('.variant-picker__input').forEach(function (input) {
        input.addEventListener('change', function () {
          updateForVariant(findMatchingVariant());
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        submitButton.disabled = true;

        window.SilkimCart.addItem(form)
          .catch(function (error) {
            if (errorEl) {
              errorEl.textContent = (error && (error.description || error.message)) || soldOutLabel;
              errorEl.hidden = false;
            }
          })
          .finally(function () {
            submitButton.disabled = !findMatchingVariant() || !findMatchingVariant().available;
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
